import jqueryPlugins from './behavior/jquery-plugins';
import * as utils from './common/utils';

import { load as loadPageData } from './components/page-data';
import header from './components/header';
import cursor from './components/cursor';
import smoothScrollingAnchors from './components/smooth-scrolling-anchors';
import propertiesMap from './components/properties-map';
import propertiesGrid from './components/properties-grid';
import arrowButtons from './components/arrow-buttons';
import galleries from './components/galleries';
import headingsWithYearFlag from './components/headings-with-year-flag';

import windowHorizontalResizeEvent from './behavior/window-horizontal-resize-event';
import scrollSmoother from './behavior/scroll-smoother';
import { trackPage } from './behavior/last-page-tracker';

import pageHome from './pages/page-home';
import pageOurProperties from './pages/page-our-properties';
import pageAbout from './pages/page-about';

log.setDefaultLevel('debug');

gsap.config({ nullTargetWarn: false });

window.utils = utils;

jqueryPlugins.register();

windowHorizontalResizeEvent.register();

window.arrowButtons = arrowButtons;

window.trackPage = trackPage;

const initializeComponents = () => {
    scrollSmoother.initialize();
    header.initialize();
    cursor.initialize();
    smoothScrollingAnchors.initialize();
    propertiesMap.initialize();
    propertiesGrid.initialize();
    arrowButtons.initialize();
    galleries.initialize();
    headingsWithYearFlag.initialize();
};

const makePageBehaviorGloballyAccessible = () => {
    window.pageHome = pageHome;
    window.pageOurProperties = pageOurProperties;
    window.pageAbout = pageAbout;
};

const createVuesCollection = () => {
    window.vues = {};
};

$(function() {
    trackPage();
    loadPageData();
    createVuesCollection();
    initializeComponents();
    makePageBehaviorGloballyAccessible();
});

